export default {
  ai_explanation: {
    title: "Wie Estimator24 funktioniert",
    intro:
      "Estimator24 nutzt künstliche Intelligenz und Datenanalyse, um den fairen Marktwert einer Immobilie anhand zahlreicher Faktoren zu bestimmen.",
    how_it_works: {
      title: "Wie der Preis berechnet wird",
      step1: "Das System findet ähnliche Wohnungen im Umkreis von bis zu 20 km.",
      step2: "Es analysiert Merkmale wie Fläche, Etage, Baujahr, Aussicht und Infrastruktur.",
      step3: "Mehrere Machine-Learning-Modelle berechnen unabhängig voneinander Prognosen.",
      step4: "Der Endpreis ist ein gewichteter Durchschnitt, angepasst an Markttrends."
    },
    models: {
      title: "Estimator24-Modelle",
      xgboost: "Ein umfassendes Modell, das alle verfügbaren Merkmale analysiert.",
      lightgbm: "Vergleicht die Immobilie mit ähnlichen Objekten in der Nähe.",
      randomforest: "Erkennt seltene Merkmalskombinationen und unterbewertete Objekte.",
      neural: "Ein neuronales Netz, trainiert auf historischen Daten und Fotos.",
      regression: "Ein statistisches Modell, das die allgemeine Marktdynamik widerspiegelt."
    },
    market: {
      title: "Was bedeutet „unter“ oder „über dem Markt“?",
      desc: "Wenn der Preis unter dem Durchschnitt des Stadtteils liegt, kann das ein gutes Angebot sein. Ein höherer Preis kann auf besseren Zustand, Aussicht oder Lage hinweisen. Estimator24 vergleicht alle Daten, um die reale Marktsituation zu zeigen."
    }
  }
}
